import { render, staticRenderFns } from "./80.vue?vue&type=template&id=0dc1e142&scoped=true&"
import script from "./80.vue?vue&type=script&lang=js&"
export * from "./80.vue?vue&type=script&lang=js&"
import style0 from "./80.vue?vue&type=style&index=0&id=0dc1e142&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc1e142",
  null
  
)

export default component.exports